import { IDataSource } from '../types/IDataSource';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IDatasourceUsageInfo } from '../types/IUsageInfo';
import { IUser } from '../types/IUser';
import { INamedItem } from '../types/resourceParts';
import { Request } from './Request';

export interface IGetDatasourcesParams extends IGetItemsParams {
}

export interface IGetDatasourcesResult extends IGetItemsResult {
  datasources?: IDataSource[];
  projects?: INamedItem[];
  users?: IUser[];
  maxStats?: IDatasourceUsageInfo;
  favorites?: string[];
  workbooks?: INamedItem[];
}

export class GetDatasourcesRequest extends Request<IGetDatasourcesParams, IGetDatasourcesResult> {
  constructor(params: IGetDatasourcesParams) {
    super('getDatasources', params);
  }
}
